class MatriculaOcorrencia {
  constructor(dados) {
    this.idMatricula = dados.idMatricula;
    this.instituicaoOrigem = dados.instituicaoOrigem;
    this.cursoAtual = dados.cursoAtual;
    this.dataMatricula = dados.dataMatricula;
  }
}
export default MatriculaOcorrencia;
